export default "__VITE_ASSET__DfrnNzXs__"